import React from "react";

interface ColorGroupProps {
  bgClass: string;
  hexColor: string;
}

const ColorGroup: React.FC<ColorGroupProps> = ({ bgClass, hexColor }) => {
  return (
    <div className="group relative">
      <div className={`h-20 w-20 rounded-full mx-2 my-2 md:my-0 ${bgClass}`}></div>
      <span
        className="invisible group-hover:visible absolute -top-6 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs py-1 px-2 rounded-md"
      >
        {hexColor}
      </span>
    </div>
  );
};

export default ColorGroup;
